import { ProtectedRoute } from '@/components/auth/ProtectedRoute';
import { AppLayout } from '@/components/layout/AppLayout';
import { WorkloadOverview } from '@/components/dashboard/WorkloadOverview';

function DashboardContent() {
  return (
    <AppLayout>
      <WorkloadOverview />
    </AppLayout>
  );
}

export default function DashboardPage() {
  return (
    <ProtectedRoute>
      <DashboardContent />
    </ProtectedRoute>
  );
}
